import { useState } from "react";
import { faqs } from "@/mocks/comics";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <section className="py-10 md:py-14 px-4 md:px-6" aria-label="常见问题">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">关于韩漫漫画网，你想知道的都在这里</p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-lg border border-background-200 overflow-hidden transition-all duration-200"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  aria-expanded={openIndex === index}
                >
                  <h3 className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</h3>
                  <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === index ? "rotate-180" : ""}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  </div>
                </button>
                <div
                  className={`px-5 overflow-hidden transition-all duration-300 ${
                    openIndex === index ? "pb-4 max-h-96" : "max-h-0"
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}